const scrollIndicator = document.getElementById("scrollIndicator")
const shallRemoveIndicator = window.scrollY < document.documentElement.clientHeight * .1

requestAnimationFrame(() => {
    const markDone = () => { scrollIndicator?.classList.add("done") }

    if (!shallRemoveIndicator) markDone()
    else document.addEventListener("scroll", markDone, { passive: true, once: true })
})